import { CommonActivityType } from './common-activity-type.enum';

/**
 * Activity types tracked in the job_activity table (PD-17797).
 * Extends CommonActivityType with job-specific types.
 */
export const JobActivityType = {
	...CommonActivityType,
	DETAILS_CHANGED: 'details_changed',
	CUSTOMER_CHANGED: 'customer_changed',
	OPPORTUNITY_CHANGED: 'opportunity_changed',
	ORDER_CHANGED: 'order_changed',
	NOTE_CHANGED: 'note_changed',
	TASK_CHANGED: 'task_changed',
	FILE_CHANGED: 'file_changed',
	COMPETITOR_CHANGED: 'competitor_changed',
	PERSON_CHANGED: 'person_changed',
	SHIP_TO_CHANGED: 'ship_to_changed',
	SUB_JOB_CHANGED: 'sub_job_changed',
} as const;

export type JobActivityType = (typeof JobActivityType)[keyof typeof JobActivityType];
